import OrderDetails from 'components/orders/orderDetails';

const OrderDetailsPage = () => {
  return <OrderDetails />;
};

export default OrderDetailsPage;
